import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const EdgeOldLogoIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1983 1216H674q0 74 23 134t63 106 94 80 115 56 126 32 130 11q81 0 153-13t140-35 136-54 137-68v434q-78 38-154 65t-155 47-159 28-168 9q-115 0-222-26t-201-76-172-121-134-160-87-194-31-223q0-126 34-240t100-211 158-170 211-122q-64 64-99 151t-46 176h729q0-110-22-192t-73-137-129-82-191-28q-132 0-264 39T465 542 246 707 78 915q15-130 55-248t104-220 149-184 188-141 224-90 255-32q78 0 156 14t153 39q148 51 264 141t195 209 120 261 42 297v255z" />
    </svg>
  ),
  displayName: 'EdgeOldLogoIcon',
});

export default EdgeOldLogoIcon;
